import { createEntityAdapter, createSlice, PayloadAction } from "@reduxjs/toolkit";
import Partner, { PartnerStatus } from "../../../models/Partner";
import { LoadableContext, RootState } from "../../store";

const partnersAdapter = createEntityAdapter<Partner>({
    selectId: partner => partner.ID,
    sortComparer: (partner1, partner2) => {
        // put archived partners at then e
        if (partner1.status !== partner2.status) {
            if (partner1.status === PartnerStatus.ARCHIVED) return 1;
            if (partner2.status === PartnerStatus.ARCHIVED) return -1;
        }
        return partner1.name.localeCompare(partner2.name)
    }
});

const initialState: LoadableContext = {
    loading: false,
    error: null,
};


export const partnersSlice = createSlice({
    name: 'partners',
    initialState: partnersAdapter.getInitialState(initialState),
    reducers: {
        startLoadingList: (state) => {
            state.loading = true;
            state.error = null;
        },
        setList: (state, { payload: partners }: PayloadAction<Partner[]>) => {
            state.loading = false;
            partnersAdapter.setAll(state, partners);
        },
        addItem: (state, { payload: partner }: PayloadAction<Partner>) => {
            state.loading = false;
            partnersAdapter.addOne(state, partner);
        },
        updateItem: (state, { payload: { ID, data } }: PayloadAction<{ ID: string, data: Partial<Partner>}>) => {
            partnersAdapter.updateOne(state, {
                id: ID,
                changes: data,
            });
        },
        setError: (state, { payload }: PayloadAction<string>) => {
            state.loading = false;
            state.error = payload;
        },
    },
});

export const PartnersActions = partnersSlice.actions;

export const {
    selectAll: selectAllPartners,
    selectById: selectPartnerById,
    selectIds: selectPartnersIds
} = partnersAdapter.getSelectors((state: RootState) => state.partners.list);

const PartnersListReducer = partnersSlice.reducer;

export default PartnersListReducer;